import { typedPageSelectors, usePage } from 'publisher/store'
import React from 'react'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'
import { RegistrationButtonEntityInterface } from 'src/shared/entities/registration-button/registration-button-entity.schema'

const TEST_ID = 'registration-button'

export interface RegistrationButtonProps {
  entity: RegistrationButtonEntityInterface
}

export const RegistrationButton = ({ entity }: RegistrationButtonProps) => {
  const locale = usePage(state => typedPageSelectors.getLocale(state))

  return (
    <BasePublisherButton
      entityOrSubEntity={entity}
      onClick={() => {
        location.assign(`/${locale}/register`)
      }}
      testId={TEST_ID}
    />
  )
}
